import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import "./themes/default.css";
import "./App.css";
import ErrorProvider from "@/06-shared/lib/error/ErrorProvider";
import { NodePage } from "@/02-pages/node";
import { TreePage } from "@/02-pages/tree";
const App = () => {
    return (_jsx(ErrorProvider, { children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(TreePage, { currentDirectoryId: null, path: [] }) }), _jsx(Route, { path: "/:nodeId", element: _jsx(NodePage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }) }));
};
export default App;
